import { render, staticRenderFns } from "./MealPlanConfirmation.vue?vue&type=template&id=43d94fac&scoped=true"
import script from "./MealPlanConfirmation.vue?vue&type=script&lang=js"
export * from "./MealPlanConfirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43d94fac",
  null
  
)

export default component.exports